@import '../../../../../../constants/spacing.module.less';
@import '../new-lineup-plan-grid-shared-styles.module.less';

.plan-header {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-auto-flow: row;
  grid-row: 1 / -1;

  gap: @space-16;

  padding: @space-24 @space-16 @space-16 @space-16;
  border-radius: 8px;

  &.is-selected {
    background-color: @selected-column-background-color;
    box-shadow: @selected-left-box-shadow, @selected-right-box-shadow, @selected-top-box-shadow, @selected-bottom-box-shadow;
  }

  &.is-current {
    background-color: @current-column-background-color;
  }
}

.shipment-limit-and-user-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: @shipment-limit-label-grid-area / @analytics-license-grid-area;
  gap: @space-8;
}

.divider {
  grid-area: @divider-grid-area;
  border-bottom: solid 1px var(--gray-DFE4E8);
}

.plan-info {
  display: grid;
  grid-template-rows: subgrid;
  grid-row: @name-grid-area / @shipment-limit-label-grid-area;
}

.plan-name-row {
  grid-area: @name-grid-area;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 28px;
}

.plan-name {
  color: var(--gray-212c36);
}

.plan-current-price {
  grid-area: @current-price-grid-area;
  color: var(--gray-212c36);
}

@keyframes highlight-flash {
  0% {
    background-color: var(--blue-DBECFE);
  }
  100% {
    background-color: transparent;
  }
}

.highlight {
  animation: highlight-flash 1.5s ease-out;
}

.plan-option-content-cost {
  display: flex;
  align-items: center;
  color: var(--gray-56595D);
}
